import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  menuPaper: {
    borderRadius: '8px',
  },
  dropdownButton: {
    transition: 'none',
    '&.MuiButtonBase-root.medium': {
      borderRadius: '4px',
      height: '20px',
      padding: '0',
      width: '20px',
      '&:hover': {
        backgroundColor: `${theme.new.color.brand[100]}`,
      },
      '&:focus': {
        backgroundColor: `${theme.new.color.brand[100]}`,
      },
      '&.Mui-focusVisible': {
        backgroundColor: `${theme.new.color.brand[100]}`,
      },
    },
  },
  menuItem: {
    borderBottom: `1px solid ${theme.new.color.line.hairline}`,
    '&:hover': {
      backgroundColor: `${theme.new.color.brand[100]}`,
    },
    '&:focus': {
      backgroundColor: `${theme.new.color.brand[100]}`,
    },
  },
}));

export default useStyles;
